import React, { useEffect, useState } from "react";
import { getCirculars } from "../../services/api/Api";
import SkeletonComponent from "../SkeletonComponent";
import { toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";
import { Link } from "react-router-dom";

const Circulars = () => {
  const [circulars, setCirculars] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCirculars = async () => {
      try {
        setLoading(true);
        const response: any = await getCirculars(2);

        let items = response?.circulars ?? response?.data ?? response ?? [];
        if (items?.data) items = items.data;
        if (!Array.isArray(items) && items?.length === undefined) {
          for (const key of Object.keys(items || {})) {
            if (Array.isArray(items[key])) {
              items = items[key];
              break;
            }
          }
        }

        setCirculars(Array.isArray(items) ? items : []);
      } catch (err) {
        console.error("Failed to fetch circulars", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCirculars();
  }, []);

  if (!loading && circulars.length === 0) return null;

  return (
    <div className="circulars-widget mt-4 mt-xl-0">
      {(loading || circulars.length > 0) && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="top-faq-headline text-start ur_ebold color28">Circulars</div>
          {!loading && (
            <Link to={`${process.env.REACT_APP_MAIN_WEBSITE_URL}circulars/`} className="color1 in_semi fs-18">
              View All
            </Link>
          )}
        </div>
      )}

      {loading ? (
        <SkeletonComponent name="Circulars" />
      ) : (
        <div className="list-group gap-3">
          {circulars.slice(0, 5).map((c: any, idx: number) => {
            const title = c.title || c.post_title || c.name || "Circular";
            const dateDisplay = c.date_display || c.date || "";
            const tag = c.tag || c.source || c?.category || "";
            const fileUrl = c.download_url;
            const interpretationUrl = c.interpretation_url || c.link || "";
            const hasInterpretation =
              c.has_interpretation === true || c.has_interpretation === "true";

            const isLast = idx === Math.min(circulars.length, 5) - 1;

            return (
              <div
                key={c.id || idx}
                className={`d-flex align-items-start justify-content-between pb-3 gap-3 ${
                  isLast ? "" : "border-bottom"
                }`}
              >
                <div>
                  <a
                    className="color1 text-decoration-none in_med lh-21 p-0"
                    href={fileUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {title}
                  </a>
                  <div className="in_med color28 mt-3 fs-12 d-flex align-items-center">
                    {dateDisplay}
                    {tag && <span className="mx-3 text-dark">•</span>}
                    {tag && (
                      <span className="border border-dark-subtle fs-14 in_med px-3 py-2 rounded-1 me-3">
                        {tag}
                      </span>
                    )}{" "}
                    {hasInterpretation && interpretationUrl && (
                      <span className="border border-dark-subtle fs-14 in_med px-3 py-2 rounded-1">
                        <Link
                          to={interpretationUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="color28"
                        >
                          Interpretation
                        </Link>
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  {fileUrl ? (
                    <a href={fileUrl} target="_blank" rel="noreferrer" className="">
                      <img src={toAbsoluteUrl("/mainsection-images/download.svg")} alt="Download" />
                    </a>
                  ) : (
                    <span className="disabled-download">
                      <img
                        src={toAbsoluteUrl("/mainsection-images/download.svg")}
                          alt="Download disabled"
                          className="cursor-not-allowed opacity-50"
                      />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Circulars;
